import React from "react";
import { createColumnHelper } from "@tanstack/react-table";
import Table from "../../../ui-components/table/table";
import Loading from "../../../ui-components/loading/loading";
import { useShipmentDockLog } from "./hooks/useMergedDockLog";

export interface ShipmentDockLogProps {
  invoiceNumber: number;
}

const columnHelper = createColumnHelper<any>();

const ShipmentDockLog: React.FC<ShipmentDockLogProps> = (props) => {
  const {
    rows,
    isLoading,
    isLoaded,
    legacyFailed,
    legacyError,
  } = useShipmentDockLog(props.invoiceNumber);

  const columns = [
    columnHelper.accessor("date", {
      id: "date",
      header: () => (
        <div className="text-center">
          Date
        </div>
      ),
      cell: (cellProps) => (
        <div className="text-center">
          { cellProps.getValue().toUiDateFormat() }
        </div>
      ),
      size: 95,
    }),
    columnHelper.accessor("time", {
      id: "time",
      header: () => (
        <div className="text-center">
          Time
        </div>
      ),
      cell: (cellProps) => (
        <div className="text-center">
          { cellProps.getValue() }
        </div>
      ),
      size: 75,
    }),
    columnHelper.accessor("event", {
      id: "event",
      header: () => (
        <div className="text-center">
          Event
        </div>
      ),
      cell: (cellProps) => (
        <div className="text-center">
          { cellProps.getValue() }
        </div>
      ),
      size: 60,
    }),
    columnHelper.accessor("serviceCenter", {
      id: "serviceCenter",
      header: () => (
        <div className="text-center">
          Term #
        </div>
      ),
      cell: (cellProps) => (
        <div className="text-center">
          { cellProps.getValue().id } { cellProps.getValue().name }
        </div>
      ),
      size: 125,
    }),
    columnHelper.accessor("door", {
      id: "door",
      header: () => (
        <div className="text-center">
          Door
        </div>
      ),
      cell: (cellProps) => (
        <div className="text-center">
          { cellProps.getValue() }
        </div>
      ),
      size: 60,
    }),
    columnHelper.accessor("orderOfItem", {
      id: "orderOfItem",
      header: () => (
        <div className="text-center">
          Seq
        </div>
      ),
      cell: (cellProps) => (
        <div className="text-center">
          { cellProps.getValue() }
        </div>
      ),
      size: 60,
    }),
    columnHelper.accessor("rollNumber", {
      id: "rollNumber",
      header: "Roll #",
      size: 120
    }),
    columnHelper.accessor("trailer", {
      id: "trailer",
      header: () => (
        <div className="text-center">
          Trailer
        </div>
      ),
      cell: (cellProps) => (
        <div className="text-center">
          { cellProps.getValue() || "" }
        </div>
      ),
      size: 100,
    }),
    columnHelper.accessor("message", {
      id: "message",
      header: "",
      size: 200
    })
  ];

  const calcMinTableHeight = () => {
    if (!rows.length) return;
    if (rows.length === 2) return 150;
    return rows.length > 2 ? 254 : 100;
  };

  return (
    <>
      {isLoading && (
        <div className="xgs-invoice-documents__loading">
          <Loading isLoading={true} />
        </div>
      )}
      {rows.length > 0 && (
        <div className="xgs-shipment-details__dock-log">
          <Table
            columns={columns}
            data={rows}
            infiniteScroll={true}
            infiniteScrollLoading={false}
            infiniteScrollHasNext={false}
            onInfiniteScroll={() => {}}
            rowHeight={75}
            minTableHeight={calcMinTableHeight()}
            strictMinTableHeight={true}
            responsive
          />
        </div>
      )}
      {rows.length === 0 && isLoaded && !legacyFailed && (
        <div className="xgs-shipment-details__tabs__no-data">There is no dock log</div>
      )}
      {legacyFailed && (
        <div className="xgs-shipment-details__tabs__error">
          {legacyError || "Error while loading dock log."}
        </div>
      )}
    </>
  );
};

export default ShipmentDockLog;
